import { useState } from 'react';
import { initialConfirm } from '../../../utils';

const Modals = ({ losesAccess }) => {
  const [open, setOpen] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [closeActive, setCloseActive] = useState(true);
  const [confirm, setConfirm] = useState(initialConfirm);

  const addUser = async () => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setIsCreated(true);
    setCurrentUser(null);
    setOpen(true);
  };

  const editUser = async (user) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setIsCreated(false);
    setCurrentUser(user);
    setOpen(true);
  };

  const askDelete = async (ids, message) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setConfirm({ open: true, ids, message, loading: false, error: '' });
  };

  const closeDeleteModal = () => {
    setConfirm(initialConfirm);
  };

  return {
    open,
    confirm,
    isCreated,
    currentUser,
    closeActive,
    setOpen,
    addUser,
    editUser,
    askDelete,
    setConfirm,
    setCloseActive,
    closeDeleteModal,
  };
};

export default Modals;
